

/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef } from "react";
import { css, keyframes } from "@emotion/react";

const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

const closeIconStyle = css`
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  align-self: flex-start;
  user-select: none;
`;

const modalOverlayStyle = css`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
  z-index: 100000;
  display: flex;
  flex-direction: column;

    @media (max-width: 480px) {
    width: 90vw;        
  }

`;

const modalContentStyle = css`
  flex: 1;
  position: relative;
  height: 100%;
`;

const modalContentInnerStyle = css`
  height: 100%;
`;

const iframeStyle = css`
  width: 100%;
  height: 100%;
  border: none;
`;


// animation container style
const animatedContainerStyle = (animatingOut) => css`
  animation: ${animatingOut ? slideOut : slideIn} 0.6s forwards;
`;

export default function UpiriaModal({ spaLink, expTitle, visible, onClose }) {
  const modalRef = useRef(null);
  const [animatingOut, setAnimatingOut] = React.useState(false);

  // Resize iframe container height to window height minus a small offset
  const resizeSpaHeight = () => {
    if (modalRef.current) {
      const screenHeight = window.innerHeight;
      modalRef.current.style.height = `${screenHeight - 4}px`;
    }
  };

  useEffect(() => {
    if (visible) {
      setAnimatingOut(false);
      document.body.style.overflow = "hidden";
      resizeSpaHeight();
      window.addEventListener("resize", resizeSpaHeight);
    } else {
      document.body.style.overflow = "visible";
      window.removeEventListener("resize", resizeSpaHeight);
    }

    return () => {
      document.body.style.overflow = "visible";
      window.removeEventListener("resize", resizeSpaHeight);
    };
  }, [visible]);

  // Close modal with animation
  const handleClose = () => {
    setAnimatingOut(true);
    document.body.style.overflow = "hidden";

    setTimeout(() => {
      setAnimatingOut(false);
      if (onClose) onClose();
    }, 600);
  };

  if (!visible && !animatingOut) return null; // Don't render if not visible or animating out

  return (
    <div
      ref={modalRef}
      css={[modalOverlayStyle, animatedContainerStyle(animatingOut)]}
      id="upiria-side-modal"
    >
      <span css={closeIconStyle} onClick={handleClose} id="closeModal">
        &times;
      </span>
      <div id="upiria-spa" css={modalContentStyle}>
        <div id="upiria-spa-content" css={modalContentInnerStyle}>
          <iframe
            title={expTitle}
            src={spaLink}
            allowTransparency="true"
            allowFullScreen
            css={iframeStyle}
          />
        </div>
      </div>
    </div>
  );
}
